(function () {
  var TRANSITION_MS = 320;

  function parseJson(id) {
    var el = document.getElementById(id);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function escapeAttr(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function normalizeStage(stage) {
    if (!stage) return null;
    var track = stage.querySelector('.ot-hero-media__track');
    if (track) return track;

    track = document.createElement('div');
    track.className = 'ot-hero-media__track';

    var existing = stage.querySelector('.product-hero__image, .product-hero__video');
    if (existing) {
      var wrap = document.createElement('div');
      wrap.className = 'ot-hero-media__item is-visible';
      wrap.appendChild(existing);
      track.appendChild(wrap);
    }

    stage.innerHTML = '';
    stage.appendChild(track);
    stage.dataset.otTrackReady = '1';
    return track;
  }

  function buildMediaElement(item) {
    if (item.type === 'video' && item.src) {
      var video = document.createElement('video');
      video.className = 'product-hero__video';
      video.controls = true;
      video.playsInline = true;
      video.preload = 'auto';
      if (item.poster) video.poster = item.poster;
      var source = document.createElement('source');
      source.src = item.src;
      source.type = 'video/mp4';
      video.appendChild(source);
      return video;
    }

    var img = document.createElement('img');
    img.className = 'product-hero__image';
    img.src = item.src;
    img.alt = item.alt || '';
    img.width = 800;
    img.height = 800;
    img.loading = 'eager';
    img.decoding = 'async';
    return img;
  }

  function pauseStageMedia(stage) {
    if (!stage) return;
    stage.querySelectorAll('video').forEach(function (video) {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (e) {}
    });
  }

  function playStageVideo(video, userActivated) {
    if (!video) return;
    video.playsInline = true;

    function attemptPlay(withSound) {
      video.muted = !withSound;
      var playPromise = video.play();
      if (!playPromise || typeof playPromise.catch !== 'function') return;
      playPromise.catch(function () {
        if (withSound) attemptPlay(false);
      });
    }

    attemptPlay(!!userActivated);
  }

  function preloadNeighbors(items, index) {
    if (!items.length) return;
    var neighbors = [index - 1, index + 1];
    neighbors.forEach(function (i) {
      var item = items[((i % items.length) + items.length) % items.length];
      if (!item || item.type === 'video') return;
      var img = new Image();
      img.src = item.src;
    });
  }

  function getDirection(from, to, count) {
    if (from === to) return 0;
    if (from === count - 1 && to === 0) return 1;
    if (from === 0 && to === count - 1) return -1;
    return to > from ? 1 : -1;
  }

  function syncWrapMediaType(stage, type) {
    if (!stage) return;
    var mediaType = type || 'image';
    stage.dataset.activeType = mediaType;
    var wrap = stage.closest('.product-hero__image-wrap');
    if (!wrap) return;
    wrap.dataset.activeType = mediaType;
    wrap.classList.toggle('is-video-active', mediaType === 'video');
  }

  function renderStage(stage, item, userActivated, direction) {
    if (!stage || !item) return;

    var track = normalizeStage(stage);
    if (!track) return;

    syncWrapMediaType(stage, item.type || 'image');

    var currentWrap = track.querySelector('.ot-hero-media__item.is-visible');
    if (!currentWrap) {
      var initial = document.createElement('div');
      initial.className = 'ot-hero-media__item is-visible';
      initial.appendChild(buildMediaElement(item));
      track.appendChild(initial);
      if (item.type === 'video') {
        playStageVideo(initial.querySelector('video'), userActivated);
      }
      preloadNeighbors([item], 0);
      return;
    }

    if (stage._otTransitioning) return;
    stage._otTransitioning = true;

    pauseStageMedia(stage);

    var incoming = document.createElement('div');
    incoming.className = 'ot-hero-media__item ot-hero-media__item--incoming';
    if (direction === 1) incoming.classList.add('is-from-right');
    if (direction === -1) incoming.classList.add('is-from-left');
    incoming.appendChild(buildMediaElement(item));
    track.appendChild(incoming);

    requestAnimationFrame(function () {
      incoming.classList.add('is-visible');
      currentWrap.classList.add('is-exiting');
      if (direction === 1) currentWrap.classList.add('is-to-left');
      if (direction === -1) currentWrap.classList.add('is-to-right');
    });

    window.setTimeout(function () {
      currentWrap.remove();
      incoming.classList.remove(
        'ot-hero-media__item--incoming',
        'is-from-right',
        'is-from-left'
      );
      stage._otTransitioning = false;
      if (item.type === 'video') {
        playStageVideo(incoming.querySelector('video'), userActivated);
      }
    }, TRANSITION_MS);
  }

  function getNavButtons(stage) {
    var wrap = stage && stage.closest('.product-hero__image-wrap');
    if (!wrap) return { prev: null, next: null };
    return {
      prev: wrap.querySelector('[data-ot-media-prev]'),
      next: wrap.querySelector('[data-ot-media-next]'),
    };
  }

  function updateNavVisibility(stage, count) {
    var wrap = stage && stage.closest('.product-hero__image-wrap');
    var nav = getNavButtons(stage);
    var show = count > 1 && !(wrap && wrap.hasAttribute('data-oo-lang-media'));
    if (nav.prev) nav.prev.hidden = !show;
    if (nav.next) nav.next.hidden = !show;
  }

  function bindSwipe(stage, gallery, itemCount) {
    var wrap = stage && stage.closest('.product-hero__image-wrap');
    if (!wrap || itemCount < 2 || wrap.hasAttribute('data-oo-lang-media')) return;

    wrap._otGallery = gallery;

    if (wrap.dataset.otSwipeReady === '1') return;
    wrap.dataset.otSwipeReady = '1';

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var swipeAxis = '';

    function activeItem() {
      return stage.querySelector('.ot-hero-media__item.is-visible');
    }

    function resetDrag(animate) {
      var item = activeItem();
      if (!item) return;
      item.style.transition = animate ? 'transform .28s cubic-bezier(.22,1,.36,1)' : 'none';
      item.style.transform = '';
      if (animate) {
        window.setTimeout(function () {
          item.style.transition = '';
        }, 280);
      }
    }

    wrap.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || e.touches.length !== 1 || stage._otTransitioning) return;
        var touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        tracking = true;
        swipeAxis = '';
      },
      { passive: true }
    );

    wrap.addEventListener(
      'touchmove',
      function (e) {
        if (!tracking || !e.touches || !e.touches[0]) return;
        var touch = e.touches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;

        if (!swipeAxis) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          swipeAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (swipeAxis !== 'x') return;

        var item = activeItem();
        if (!item) return;
        var resist = 0.42;
        item.style.transition = 'none';
        item.style.transform = 'translateX(' + dx * resist + 'px)';
      },
      { passive: true }
    );

    wrap.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;

        var touch = e.changedTouches && e.changedTouches[0];
        var api = wrap._otGallery;
        if (!touch || !api || swipeAxis !== 'x') {
          resetDrag(true);
          return;
        }

        var dx = touch.clientX - startX;
        var minSwipe = 42;

        if (Math.abs(dx) < minSwipe) {
          resetDrag(true);
          return;
        }

        resetDrag(false);
        if (dx < 0) api.goNext();
        else api.goPrev();
      },
      { passive: true }
    );
  }

  function bindGallery(stage, thumbs, items) {
    var currentIndex = 0;
    normalizeStage(stage);

    function syncThumbs(index) {
      if (!thumbs) return;
      var activeThumb = null;
      thumbs.querySelectorAll('.ot-media-thumb').forEach(function (thumb, i) {
        var on = i === index;
        thumb.classList.toggle('is-active', on);
        if (on) activeThumb = thumb;
      });
      if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    function goTo(index, userActivated) {
      if (!items.length || stage._otTransitioning) return;
      var nextIndex = ((index % items.length) + items.length) % items.length;
      if (nextIndex === currentIndex) return;
      var direction = getDirection(currentIndex, nextIndex, items.length);
      currentIndex = nextIndex;
      renderStage(stage, items[currentIndex], userActivated, direction);
      syncThumbs(currentIndex);
      preloadNeighbors(items, currentIndex);
    }

    function goPrev() {
      goTo(currentIndex - 1, true);
    }

    function goNext() {
      goTo(currentIndex + 1, true);
    }

    var nav = getNavButtons(stage);
    if (nav.prev) {
      nav.prev.onclick = function () {
        goPrev();
      };
    }
    if (nav.next) {
      nav.next.onclick = function () {
        goNext();
      };
    }

    updateNavVisibility(stage, items.length);
    bindSwipe(stage, { goPrev: goPrev, goNext: goNext }, items.length);
    preloadNeighbors(items, currentIndex);

    return {
      goTo: goTo,
      goPrev: goPrev,
      goNext: goNext,
    };
  }

  function renderThumbs(container, items, onPick) {
    if (!container) return;
    var wrap = document.getElementById('product-image-wrap');
    if (wrap && wrap.hasAttribute('data-oo-lang-media')) {
      container.innerHTML = '';
      container.hidden = true;
      return;
    }
    container.hidden = false;
    container.innerHTML = '';
    items.forEach(function (item, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-thumb ot-media-thumb' + (index === 0 ? ' is-active' : '');
      btn.setAttribute('aria-label', item.alt || 'Product media');
      if (item.type === 'video') {
        btn.innerHTML =
          '<span class="ot-media-thumb__play" aria-hidden="true">▶</span><img src="' +
          escapeAttr(item.thumb) +
          '" alt="" width="64" height="64" loading="lazy">';
      } else {
        btn.innerHTML =
          '<img src="' +
          escapeAttr(item.thumb) +
          '" alt="" width="64" height="64" loading="lazy">';
      }
      btn.addEventListener('click', function () {
        onPick(item, index);
      });
      container.appendChild(btn);
    });
  }

  function fallbackItem(imgEl) {
    if (!imgEl) return null;
    var src = imgEl.getAttribute('src');
    if (!src) return null;
    return { type: 'image', src: src, thumb: src, alt: imgEl.getAttribute('alt') || '' };
  }

  function mountGallery(opts) {
    var stage = document.getElementById(opts.stageId);
    var thumbs = document.querySelector(opts.thumbsSelector);
    var items = parseJson(opts.jsonId);
    var imgEl = opts.mainId ? document.getElementById(opts.mainId) : null;
    var userActivated = !!opts.userActivated;

    if (!stage) return null;

    if (!items.length) {
      var fb = fallbackItem(imgEl);
      if (fb) renderStage(stage, fb, false, 0);
      if (thumbs) thumbs.innerHTML = '';
      updateNavVisibility(stage, 0);
      return null;
    }

    normalizeStage(stage);
    stage._otTransitioning = false;
    var track = stage.querySelector('.ot-hero-media__track');
    if (track) track.innerHTML = '';
    renderStage(stage, items[0], userActivated, 0);
    var gallery = bindGallery(stage, thumbs, items);
    renderThumbs(thumbs, items, function (item, index) {
      gallery.goTo(index, true);
    });
    return gallery;
  }

  window.OTProductMedia = {
    loadBlend: function (opts) {
      var stage = document.getElementById(opts.stageId);
      if (stage && stage.closest('[data-oo-lang-media]')) return;
      mountGallery(opts);
    },

    initStatic: function (opts) {
      var stage = document.getElementById(opts.stageId);
      if (stage && stage.closest('[data-oo-lang-media]')) return;
      var thumbs = document.querySelector(opts.thumbsSelector);
      var items = parseJson(opts.jsonId);
      if (!stage || !items.length) return;

      normalizeStage(stage);
      var gallery = bindGallery(stage, thumbs, items);
      renderThumbs(thumbs, items, function (item, index) {
        gallery.goTo(index, true);
      });
    },
  };
})();
